import { render, staticRenderFns } from "./UltimateTz.vue?vue&type=template&id=c15c7e6a&"
import script from "./UltimateTz.vue?vue&type=script&lang=js&"
export * from "./UltimateTz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports